export interface ConversionPreviewProps {
  amount: number;
  fromCurrency: string;
  toCurrency: string;
  label?: string;
  getRate: (from: string, to: string) => number | null;
  isLoadingRates: boolean;
}

export function ConversionPreview({
  amount,
  fromCurrency,
  toCurrency,
  label,
  getRate,
  isLoadingRates,
}: ConversionPreviewProps) {
  if (fromCurrency === toCurrency || amount <= 0) {
    return null;
  }

  const rate = !isLoadingRates ? getRate(fromCurrency, toCurrency) : null;

  const prefix = label ? `${label}: ` : '';

  if (rate !== null) {
    const convertedAmount = Math.round(amount * rate * 100) / 100;
    return (
      <p className="text-sm text-muted-foreground">
        {prefix}{amount} {fromCurrency} will be converted to {convertedAmount} {toCurrency}{' '}
        (1 {fromCurrency} = {rate} {toCurrency})
      </p>
    );
  }

  return (
    <p className="text-sm text-muted-foreground">
      {prefix}{amount} {fromCurrency} will be converted to {toCurrency}
    </p>
  );
}
